__turbopack_context__.v({
  "tags-control": "TagsRoll-module-sass-module__kamyFG__tags-control",
  "tags-control--next": "TagsRoll-module-sass-module__kamyFG__tags-control--next",
  "tags-control--prev": "TagsRoll-module-sass-module__kamyFG__tags-control--prev",
  "tags-control--visible": "TagsRoll-module-sass-module__kamyFG__tags-control--visible",
  "tags-item": "TagsRoll-module-sass-module__kamyFG__tags-item",
  "tags-item--last": "TagsRoll-module-sass-module__kamyFG__tags-item--last",
  "tags-link": "TagsRoll-module-sass-module__kamyFG__tags-link",
  "tags-list": "TagsRoll-module-sass-module__kamyFG__tags-list",
});
